// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2nOPB","detailsBorder":"styles_detailsBorder__24v3Z"};